import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function LockRegular(rowId) {
  const [token, setToken] = useState("");
  const queryClient = useQueryClient();

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    if (JSON.parse(localStorage.getItem("auth")) === null || token === null) {
      navigate("/Login");
    }
  }, []);

  //修改帳號狀態
  const UpdateAccountStatus = async () => {
    const data = {
      Data: rowId,
    };
    const res = await apiClient.postAes("api/account/Status/Security", data);
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };

  const { data, mutate, isSuccess, isLoading } = useMutation(
    UpdateAccountStatus,
    {
      onSuccess: () => {
        queryClient.invalidateQueries("sendSearchData");
      },
    }
  );

  useEffect(() => {
    const code = +data?.Code;

    if (isSuccess && code === 0) {
      alert("修改狀態成功");
    }
    if (code === 1 || code === 2) {
      alert(data?.Message);
    }
  }, [data]);

  return (
    <Container
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        mutate({ UpdateAccountStatus });
      }}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke="#057AFF" />k
      <path
        d="M10.2143 9.375V10.5H13.7857V9.375C13.7857 8.33906 12.9866 7.5 12 7.5C11.0134 7.5 10.2143 8.33906 10.2143 9.375ZM8.78571 10.5V9.375C8.78571 7.51172 10.2254 6 12 6C13.7746 6 15.2143 7.51172 15.2143 9.375V10.5H15.5714C16.3594 10.5 17 11.1727 17 12V16.5C17 17.3273 16.3594 18 15.5714 18H8.42857C7.64063 18 7 17.3273 7 16.5V12C7 11.1727 7.64063 10.5 8.42857 10.5H8.78571Z"
        fill="#057AFF"
      />
    </Container>
  );
}

export default LockRegular;
